<template>
  <div class="statistics-page" v-if="dataSource">
    <div>
      <div class="statistics__deadline">
        <span>统计时间截止到：{{ dataSource.timeStamp }}</span>
      </div>
      <div class="statistics__sum">
        <ul>
          <li v-for="(item, index) in sumList" :key="index">
            <div class="title">
              <span>{{ item.name }}</span>
              <div style="height: 18px">
                <info-tooltip :content="item.prompt" placement="bottom-start" />
              </div>
            </div>
            <div class="count">{{ dataSource[item.key1] }}</div>
            <div class="new">
              昨日新增：<span>{{ dataSource[item.key2] }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="statistics__chart">
        <el-row class="line" v-if="false">
          <el-col class="spe1" :span="16">
            <div class="tab">
              <span
                v-for="(item, index) in tabList"
                :key="index"
                :class="{
                  active: index === tabIndex
                }"
                @click="tabIndex = index"
                >{{ item.name }}</span
              >
            </div>
            <div class="content">
              <template v-for="(item, index) in tabList">
                <section v-if="index === tabIndex" :key="index">
                  <statistic-bar1
                    :commonFont="14"
                    :dataList="dataSource[item.key]"
                  />
                </section>
              </template>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tltle">政策主题分布</div>
            <div class="content">
              <section>
                <statistic-pie1
                  :commonFont="14"
                  :dataList="dataSource['policyTypeList']"
                />
              </section>
            </div>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="8">
            <div class="tltle">成果领域分布</div>
            <div class="content">
              <section>
                <statistic-pie1
                  :commonFont="14"
                  :dataList="dataSource['achvFieldList']"
                />
              </section>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tltle">需求领域分布</div>
            <div class="content">
              <section>
                <statistic-pie1
                  :commonFont="14"
                  :dataList="dataSource['reqFieldList']"
                />
              </section>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tltle">对接类型分布</div>
            <div class="content">
              <section>
                <statistic-pie2
                  :commonFont="12"
                  :dataList="dataSource['projectTypeList']"
                />
              </section>
            </div>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="8">
            <div class="tltle">专利领域分布</div>
            <div class="content">
              <section>
                <statistic-bar2
                  :commonFont="12"
                  :dataList="dataSource['patentFieldList']"
                />
              </section>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tltle">服务咨询分布</div>
            <div class="content">
              <section>
                <statistic-bar3
                  :commonFont="12"
                  :dataList="dataSource['serviceTypeList']"
                />
              </section>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="tltle">最新对接</div>
            <div class="content">
              <section>
                <div class="newest">
                  <ul>
                    <li
                      v-for="(item, index) in dataSource[
                        'newProjectList'
                      ].slice(0, 3)"
                      :key="item.id"
                      @click="handleSkip(item)"
                    >
                      <div class="tag">
                        <b>{{ index + 1 }}</b>
                      </div>
                      <span class="fn-text-ellipsis"> {{ item.name }}</span>
                    </li>
                  </ul>
                  <div class="tltle">最新发布</div>
                  <ul>
                    <li
                      v-for="(item, index) in dataSource['newDataList'].slice(
                        0,
                        3
                      )"
                      :key="item.id"
                      @click="handleSkip(item)"
                    >
                      <div class="tag">
                        <b>{{ index + 1 }}</b>
                      </div>
                      <span class="fn-text-ellipsis"> {{ item.name }}</span>
                    </li>
                  </ul>
                </div>
              </section>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "statistics",
  data() {
    return {
      dataSource: null,
      tabIndex: 0,
      tabList: [
        {
          name: "成果发布",
          key: "achvMonthList"
        },
        {
          name: "需求发布",
          key: "reqMonthList"
        },
        {
          name: "专利发布",
          key: "patentMonthList"
        }
      ],
      sumList: [
        {
          name: "成果总数",
          key1: "achvCount",
          key2: "achvYesterdayCount",
          prompt: "技术成果与产品成果的总数量"
        },
        {
          name: "需求总数",
          key1: "reqCount",
          key2: "reqYesterdayCount",
          prompt: "企业需求的总数量"
        },
        {
          name: "对接总数",
          key1: "projectCount",
          key2: "projectYesterdayCount",
          prompt: "成果对接、需求对接与专利对接的总数量"
        },
        {
          name: "专利总数",
          key1: "patentCount",
          key2: "patentYesterdayCount",
          prompt: "专利的总数量"
        },
        {
          name: "政策总数",
          key1: "policyCount",
          key2: "policyYesterdayCount",
          prompt: "政策通知与政策解读的总数量"
        },
        {
          name: "资讯活动",
          key1: "newsCount",
          key2: "newsYesterdayCount",
          prompt: "新闻资讯与创新活动的总数量"
        }
      ]
    };
  },
  created() {
    this.loadDataSource();
  },
  methods: {
    handleSkip({ id, type }) {
      switch (type) {
        case 1:
          // 技术
          this.redirectByPathBlank(
            `/admin/dataManage/achievementInfo/modification`,
            {
              id,
              achvType: "tech"
            }
          );
          break;
        case 7:
          // 产品
          this.redirectByPathBlank(
            `/admin/dataManage/achievementInfo/modification`,
            {
              id,
              achvType: "prod"
            }
          );
          break;
        case 2:
          // 需求
          this.redirectByPathBlank(
            `/admin/dataManage/demandInfo/modification`,
            {
              id
            }
          );
          break;
        case 3:
          // 专利
          this.redirectByPathBlank(
            `/admin/dataManage/patentInfo/modification`,
            {
              id
            }
          );
          break;
        case 4:
          // 对接成果
          this.redirectByPathBlank(`/admin/dockingManage/achDockingInfo`, {
            id
          });
          break;
        case 5:
          // 对接需求
          this.redirectByPathBlank(`/admin/dockingManage/demDockingInfo`, {
            id
          });
          break;
        case 6:
          // 对接专利
          this.redirectByPathBlank(`/admin/dockingManage/patDockingList`);
          break;
      }
    },
    loadDataSource() {
      this.$api("statistics", "getData", {}).then((res) => {
        this.dataSource = res;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.statistics-page {
  overflow: auto;
  > div {
    min-width: 1400px;
  }
  .statistics__deadline {
    margin-bottom: 20px;
    line-height: 1;
    font-size: 14px;
    color: #999999;
  }
  .statistics__sum {
    margin-bottom: 20px;
    ul {
      display: flex;
      li {
        flex: 1;
        box-sizing: border-box;
        padding: 0 20px;
        margin-right: 20px;
        background: #ffffff;
        &:last-child {
          margin-right: 0;
        }
        .title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 52px;
        }
        .count {
          line-height: 1;
          font-size: 26px;
          font-weight: bold;
        }
        .new {
          padding: 4px 20px;
          margin: 15px 0 12px;
          line-height: 20px;
          font-size: 14px;
          color: #38912c;
          border-radius: 14px;
          background: rgba(56, 145, 44, 0.1);
          span {
            padding-right: 18px;
            background-image: url("~@/assets/images/icon_new_add.png");
            background-repeat: no-repeat;
            background-position: right 0 center;
            background-size: 10px auto;
          }
        }
      }
    }
  }
  .statistics__chart {
    .line {
      margin-bottom: 20px;
      .el-col {
        padding-right: 20px;
        background-color: #fff;
        background-clip: content-box;
        &:last-child {
          padding-right: 0;
        }
        &.spe1 {
          padding-right: 0;
          .content {
            padding-top: 21.2%;
          }
        }
        .tltle {
          padding: 0 20px;
          line-height: 56px;
          font-size: 16px;
          font-weight: bold;
        }
        .tab {
          display: flex;
          padding: 11px 20px;
          span {
            margin-right: 50px;
            border-bottom: 2px solid transparent;
            line-height: 2;
            font-size: 16px;
            color: #666666;
            cursor: pointer;
            &.active {
              border-bottom: 2px solid #2573d9;
              font-weight: bold;
              color: #2573d9;
            }
          }
        }
        .content {
          position: relative;
          height: 230px;
          // padding-top: 42.4%;
          > section {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            /deep/ .graph {
              height: 100%;
            }
            .newest {
              display: flex;
              flex-direction: column;
              height: 100%;
              .tltle {
                flex: none;
                line-height: 36px;
              }
              ul {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                height: 100%;
                padding: 0 20px;
                li {
                  position: relative;
                  padding-left: 30px;
                  cursor: pointer;
                  &:nth-child(1) {
                    .tag {
                      background: #c42a36;
                    }
                  }
                  &:nth-child(2) {
                    .tag {
                      background: #ee902b;
                    }
                  }
                  &:nth-child(3) {
                    .tag {
                      background: #38912c;
                    }
                  }
                  @supports not (aspect-ratio: 1) {
                    .tag {
                      height: 20px;
                      width: 20px;
                    }
                  }
                  .tag {
                    position: absolute;
                    left: 0;
                    top: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    aspect-ratio: 1;
                    border-radius: 50%;
                    font-size: 14px;
                    font-weight: 400;
                    color: #ffffff;
                    transform: translateY(-50%);
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
